import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { MinusIcon, PlusIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UISpace } from '@gohighlevel/ghl-ui';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UINumberOfVariations',
    props: {
        numberOfVariations: {
            type: Number,
            default: 3,
        },
        max: {
            type: Number,
            default: 5,
        },
        min: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update'],
    setup(__props, { emit: emits }) {
        const props = __props;
        function setNumberOfVariation(variation) {
            const noOfVariations = props.numberOfVariations + variation;
            if (noOfVariations > 0 && noOfVariations <= props.max) {
                emits('update', noOfVariations);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UISpace), { align: 'center' }, {
                default: _withCtx(() => [
                    _createVNode(_unref(UIButton), {
                        id: "content-ai-new-content-modal-form-variation-decrement",
                        disabled: __props.numberOfVariations == __props.min || __props.disabled,
                        onClick: _cache[0] || (_cache[0] = ($event) => (setNumberOfVariation(-1)))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(MinusIcon), { class: "w-4 h-4 text-black" })
                        ]),
                        _: 1
                    }, 8, ["disabled"]),
                    _createElementVNode("span", null, _toDisplayString(__props.numberOfVariations), 1),
                    _createVNode(_unref(UIButton), {
                        id: "content-ai-new-content-modal-form-variation-increment",
                        disabled: __props.numberOfVariations == __props.max || __props.disabled,
                        onClick: _cache[1] || (_cache[1] = ($event) => (setNumberOfVariation(1)))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-black" })
                        ]),
                        _: 1
                    }, 8, ["disabled"])
                ]),
                _: 1
            }));
        };
    }
});
